// Zariknyaa page change: fades in the logo + buttis cover (snippets/zk-splash.liquid) when a
// link or form leaves the page, and flags the next page to open with the cover already up.
(function () {
  if (window.zkLoader) return;
  var KEY = 'zk-nav-at';
  var DELAY = 120;
  var GUARD = 8000;
  var pending;

  function start() {
    if (!window.zkSplash) return;
    document.documentElement.classList.add('zk-splash-in');
    window.zkSplash.show(GUARD);
    try { sessionStorage.setItem(KEY, String(Date.now())); } catch (e) {}
  }
  function done() {
    clearTimeout(pending);
    if (window.zkSplash) window.zkSplash.lift();
  }
  function soon(e) {
    clearTimeout(pending);
    // Re-checked after the delay: drawers and AJAX forms cancel the event in later handlers.
    pending = setTimeout(function () { if (!e.defaultPrevented) start(); }, DELAY);
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || a.hasAttribute('download') || (a.target && a.target !== '_self')) return;
    var u = new URL(a.href, location.href);
    if (u.origin !== location.origin || !/^https?:$/.test(u.protocol)) return;
    if (u.pathname === location.pathname && u.search === location.search) return;
    soon(e);
  });
  document.addEventListener('submit', function (e) {
    if (!e.defaultPrevented && (!e.target.target || e.target.target === '_self')) soon(e);
  });

  window.zkLoader = { start: start, done: done };
})();

// Image placeholders: the box around a photo that is still downloading gets .zk-img-wait
// (buttis on cream, zk-loader.css) until the photo loads or fails.
(function () {
  if (window.zkImgWait) return;
  var CLS = 'zk-img-wait';
  var SKIP = 'zk-splash, .header__heading-link, .zk-dhead__logo, .zkf-logo, .sr-powered-by';
  var MIN = 32;
  var queue = [];
  var queued = false;

  function settle(img) {
    var box = img.__zkBox;
    if (box) { box.classList.remove(CLS); img.__zkBox = null; }
  }
  function boxOf(img) {
    var el = img.parentElement;
    for (var i = 0; el && i < 3; i++, el = el.parentElement) {
      if (el.tagName !== 'PICTURE' && getComputedStyle(el).display !== 'inline') return el;
    }
    return null;
  }
  function flush() {
    queued = false;
    var list = queue.splice(0);
    var marks = [];
    for (var i = 0; i < list.length; i++) {
      var img = list[i];
      if (!img.isConnected || img.complete || img.closest(SKIP)) { settle(img); continue; }
      var box = boxOf(img);
      if (!box) continue;
      var r = box.getBoundingClientRect();
      if (r.width && r.height && (r.width < MIN || r.height < MIN)) continue;
      marks.push([img, box]);
    }
    for (var j = 0; j < marks.length; j++) {
      if (marks[j][0].__zkBox && marks[j][0].__zkBox !== marks[j][1]) settle(marks[j][0]);
      marks[j][1].classList.add(CLS);
      marks[j][0].__zkBox = marks[j][1];
    }
  }
  function add(img) {
    queue.push(img);
    if (!queued) { queued = true; requestAnimationFrame(flush); }
  }
  function scan(node) {
    if (node.nodeType !== 1) return;
    if (node.tagName === 'IMG') add(node);
    else if (node.firstElementChild) node.querySelectorAll('img').forEach(add);
  }

  function onDone(e) { if (e.target && e.target.tagName === 'IMG') settle(e.target); }
  document.addEventListener('load', onDone, true);
  document.addEventListener('error', onDone, true);

  new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      var rec = records[i];
      if (rec.type === 'attributes') { if (rec.target.tagName === 'IMG') add(rec.target); }
      else for (var k = 0; k < rec.addedNodes.length; k++) scan(rec.addedNodes[k]);
    }
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'srcset'] });

  scan(document.body);
  window.zkImgWait = { scan: scan };
})();
